import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// Components
import { Text, ListingStatusHead } from './..'

// Helpers
import { capitalizeFirstLetter, getRandomInt } from '../../helpers'

// Styles
import styles from './EvaluationTile.module.scss'

const EvaluationTile = ({ text, color, thinking, subText }) => {
  const enhancedColor = thinking ? 'white' : color || 'pink'
  const botHeadColor = thinking ? 'pink' : color

  const robotSpeak = useMemo(() => {
    if (thinking) {
      const words = ['beep', 'boop', 'blop', 'bzzz']
      const first = capitalizeFirstLetter(words[getRandomInt(4)])
      const second = words[getRandomInt(4)]
      const third = words[getRandomInt(4)]

      return `${first} ${second} ${third}...`
    }
  }, [thinking])

  return (
    <div className={styles.evalRow}>
      <div className={styles.evalBotHead}>
        <ListingStatusHead color={botHeadColor} spin={thinking} />
      </div>
      <div className={styles.evalCol}>
        <Text
          color={enhancedColor}
          size='xl'
          weight='bold'
          letterSpacing='large'
        >
          {thinking ? robotSpeak : text}
        </Text>
        <Text color='white' size='s'>
          {thinking ? 'Crunching your numbers' : subText}
        </Text>
      </div>
    </div>
  )
}

EvaluationTile.propTypes = {
  color: PropTypes.oneOf(['green', 'orange', 'red', 'pink']),
  subText: PropTypes.string,
  text: PropTypes.string,
  thinking: PropTypes.bool,
}

export default EvaluationTile
